import { render } from "./AnimalDetail.vue?vue&type=template&id=157ec033&scoped=true"
import script from "./AnimalDetail.vue?vue&type=script&lang=js"
export * from "./AnimalDetail.vue?vue&type=script&lang=js"

import "./AnimalDetail.vue?vue&type=style&index=0&id=157ec033&lang=css"
import "./AnimalDetail.vue?vue&type=style&index=1&id=157ec033&lang=css"
import "./AnimalDetail.vue?vue&type=style&index=2&id=157ec033&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157ec033"]])

export default __exports__